import React from "react";
import {
  WorkspacePanel,
  WorkspaceToolbar,
  WorkspaceBody,
  WorkspaceScroll,
  WorkspaceTableScroll,
} from "./WorkspacePanel";

/**
 * Стандартная страница кабинета: фиксированная шапка/фильтры + прокрутка внутри viewport.
 *
 * bodyScroll:
 * - "scroll" — весь контент прокручивается (дашборд, настройки, карточки)
 * - "table"  — прокрутка таблицы/списка (табель, ведомость, админ-таблицы)
 * - "zones"  — несколько зон внутри (чат: сообщения + поле ввода)
 */
export default function AppPage({
  testId,
  toolbar,
  children,
  bodyScroll = "scroll",
  className = "",
}) {
  let body;
  if (bodyScroll === "table") {
    body = <WorkspaceTableScroll className={className}>{children}</WorkspaceTableScroll>;
  } else if (bodyScroll === "scroll") {
    body = <WorkspaceScroll className={className}>{children}</WorkspaceScroll>;
  } else {
    body = <WorkspaceBody className={className}>{children}</WorkspaceBody>;
  }

  return (
    <WorkspacePanel testId={testId}>
      {toolbar != null && <WorkspaceToolbar>{toolbar}</WorkspaceToolbar>}
      {body}
    </WorkspacePanel>
  );
}
